<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
        <v-flex xs12>
          <h4>{{ formTitle }}</h4>
        </v-flex>
        <v-flex xs12>
            <v-tabs
                    v-model="tab"
            >
                <v-tab href="#tab-1">
                    Основные данные
                </v-tab>
                <v-tab-item
                        :value="'tab-1'">
                    <v-card>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-file-input
                                                :error-messages="requiredRulingErrors('file_path')"
                                                @blur="$v.childrenGardenFile.file_path.$touch()"
                                                accept=".dbf"
                                                label="Файл"
                                                show-size
                                                truncate-length="50"
                                                v-if="!childrenGardenFile.filename"
                                                v-model="childrenGardenFile.file_path"
                                        ></v-file-input>
                                        <div v-if="childrenGardenFile.filename">
                                            <b>Файл:</b> {{childrenGardenFile.filename}}
                                            <v-btn
                                                    @click.native="downloadFile({urlFile: childrenGardenFile.file_path,
                                                                      filename: childrenGardenFile.filename
                                                                      })"
                                                    class="ml-3"
                                                    color="indigo"
                                                    icon
                                            >
                                                <v-icon>mdi-cloud-download</v-icon>
                                            </v-btn>
                                            <v-progress-circular
                                                    class="ml-3"
                                                    color="primary"
                                                    indeterminate
                                                    v-if="listLoading.includes('downloadFile_' + childrenGardenFile.file_path)"
                                            ></v-progress-circular>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12>
                                        <div v-if="childrenGardenFile.protocol_path">
                                            <b>Файл протокола:</b> Протокол ошибок.txt
                                            <v-btn
                                                    @click.native="downloadFile({urlFile: childrenGardenFile.protocol_path,
                                                                                  filename: 'Протокол ошибок.txt',
                                                                                  mime: 'text/plain'
                                                                                  })"
                                                    class="ml-3"
                                                    color="indigo"
                                                    icon
                                            >
                                                <v-icon>mdi-cloud-download</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-flex>
                                    <v-flex class="pt-5" xs12>
                                        <p><strong>Тип обработки: </strong>
                                            <span
                                                    v-if="'type_reestr' in childrenGardenFile && childrenGardenFile.processing_type !== null"
                                            >{{childrenGardenFile.processing_type.name}}</span>
                                        </p>
                                        <p><strong>Статус обработки:</strong>
                                            <span
                                                    v-if="'type_reestr' in childrenGardenFile && childrenGardenFile.process_status !== null"
                                            >{{childrenGardenFile.process_status.name}}</span>
                                        </p>
                                        <p><strong>Тип реестра:</strong>
                                            <span
                                            v-if="'type_reestr' in childrenGardenFile && childrenGardenFile.type_reestr !== null"
                                            >
                                                {{childrenGardenFile.type_reestr.name}}
                                            </span>
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-progress-linear
                                    color="primary"
                                    indeterminate
                                    v-if="listLoading.findIndex(function(el) {return el.indexOf('kindergarten-insertFile-') > -1}) > -1"
                            ></v-progress-linear>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
                <v-tab href="#tab-2">
                    Журнал обработки файла
                </v-tab>
                <v-tab-item
                        :value="'tab-2'">
                    <v-card>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <table class="table-log">
                                            <tr>
                                                <th>Дата</th>
                                                <th>Операция обработки</th>
                                            </tr>
                                            <tbody>
                                            <tr :key="log.id" v-for="log in logOperationFile">
                                                <td>{{log.create_date|date_time}}</td>
                                                <td>{{log.operation.operation}}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab href="#tab-3">
                    Системные данные
                </v-tab>
                <v-tab-item
                        :value="'tab-3'">
                    <system-form :system-info=systemInfo></system-form>
                </v-tab-item>
            </v-tabs>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        @click.native="saveFile()"
                        v-if="!childrenGardenFile.filename"
                >Сохранить</v-btn>
                <v-btn
                        @click.native="cancel()"
                >Назад
                </v-btn>
            </v-card-actions>
        </v-flex>
        <v-flex md8 xs12>
            <router-view></router-view>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { helpers, required } from 'vuelidate/lib/validators'
import SystemForm from '../common/systemForm'
import moment from 'moment'

const maxSizeFile = (size) =>
  (value) => {
    if (value && (typeof value === 'object')) {
      return value.size < size
    }
    return true
  }

function isFileName (file) {
  // Проверяем, что в file имеется атрибут name
  if (file === undefined) {
    return false
  }
  if (file === null) {
    return false
  }
  if (typeof file !== 'object') {
    return false
  }
  if (!('name' in file)) {
    return false
  }
  if (typeof file.name !== 'string') {
    return false
  }
  if (file.name.split('_').length !== 4) {
    return false
  }
  return true
}

const filename = (value) => {
  if (!isFileName(value)) {
    return false
  }
  const filename0 = helpers.regex('filename', /^[a-zA-Zа-яА-Я]{3}_[0-9]{6}_[0-9]{13,15}_[0-9]{2}.(dbf|DBF){1}$/)
  return filename0(value.name)
}

const filenameDate = (value) => {
  // Проверяем в имени файла дату
  if (!isFileName(value)) {
    return false
  }
  let nameArr = value.name.split('_')
  return moment(nameArr[1], 'YYMMDD').isValid()
}

const filenamePrefix = (value) => {
  // Проверяем в имени префикс
  if (!isFileName(value)) {
    return false
  }
  let nameArr = value.name.split('_')
  return nameArr[0] === 'SAD'
}

const filenameOGRN = (ogrn) =>
  (value) => {
    // Проверяем в имени ОГРН
    if (!isFileName(value)) {
      return false
    }
    let nameArr = value.name.split('_')
    return nameArr[2] === ogrn
  }

export default {
  components: { SystemForm },
  data () {
    return {
      menuFilter: false
    }
  },
  mixins: [validationMixin],
  validations () {
    return {
      childrenGardenFile: {
        file_path: {
          required, maxSizeFile: maxSizeFile(20000000), filename, filenamePrefix, filenameDate, filenameOGRN: filenameOGRN(this.user.department.ogrn)
        }
      }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    formTitle () {
      return this.$route.params.registry_id === 'new' ? 'Добавить реестр' : 'Реестр'
    },
    childrenGardenFile () {
      return this.$store.getters['kindergartenRegistries/childrenGardenFile']
    },
    logOperationFile () {
      return this.$store.getters['kindergartenRegistries/logOperationFile']
    },
    tab: {
      get () {
        return this.$store.getters['kindergartenRegistries/tab']
      },
      set (value) {
        return this.$store.commit(
          'kindergartenRegistries/setTab',
          value)
      }
    },
    systemInfo () {
      return {
        id: this.childrenGardenFile.id,
        date_created: this.childrenGardenFile.create_date,
        date_of_change: this.childrenGardenFile.time_stamp,
        user: this.childrenGardenFile.user_info
      }
    },
    user () {
      return this.$store.getters['auth/user']
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.registry_id
      if (id === 'new') {
        this.$store.commit('kindergartenRegistries/setDefaultChildrenGardenFile')
      } else {
        this.$store.dispatch('kindergartenRegistries/fetchChildrenGardenFile', {
          id: id
        })
        this.$store.dispatch('kindergartenRegistries/fetchLogOperationFile', { file_id: id })
      }
    },
    downloadFile (link) {
      this.$store.dispatch('common/downloadFile', link)
    },
    saveFile () {
      this.$v.childrenGardenFile.$touch()
      if (!this.$v.childrenGardenFile.$invalid) {
        this.$store.dispatch('kindergartenRegistries/insertFile', this.childrenGardenFile)
          .then(() => {
            if (this.$route.params.registry_id === 'new') {
              this.$router.push({
                name: 'kindergarten_registry',
                params: {
                  'registry_id': this.childrenGardenFile.id
                }
              })
            }
          })
      }
    },
    cancel () {
      this.$router.push({ name: 'kindergarten_list' })
    },
    requiredRulingErrors (fieldName) {
      const errors = []
      const field = this.$v.childrenGardenFile[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('maxSizeFile')) {
        !field.maxSizeFile && errors.push('Размер файла не должен превышать 20 Мбайт')
      }
      if (field.hasOwnProperty('filename')) {
        !field.filename && errors.push('Некорректное имя файла')
      }
      if (field.hasOwnProperty('filenamePrefix')) {
        !field.filenamePrefix && errors.push('В имени файла некорректно указана префикс')
      }
      if (field.hasOwnProperty('filenameDate')) {
        !field.filenameDate && errors.push('В имени файла некорректно указана дата')
      }
      if (field.hasOwnProperty('filenameOGRN')) {
        !field.filenameOGRN && errors.push('В имени файла ОГРН не соответсвует ОГРН организации текущего пользователя ' + this.user.department.ogrn)
      }
      return errors
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .table-log
  {
      border-collapse: collapse;
      width: 100%;
  }
  .table-log td, .table-log th
  {
      border-bottom: 1px solid black;
      padding: 5px 30px;

  }
</style>
